/**
 * Episodes list
 */

class MWF_EpisodesList {
    constructor () {
        this.initEvents();
    }

    initEvents () {
        this.search = $('.episodes-search-form');
        this.listWrapper = $('.episodes-list');
        this.selectedCategory = '';

        if (!(this.listWrapper.length && this.search.length)) {
            return;
        }

        this.loadMore = $('.episodes-list-load-more'); 
        this.categorySelector = $('#episodes-list-categories');
        this.items = this.listWrapper.find('.episodes-list-item');
        this.fixSearchAttributes();
        this.input = this.search.find('.custom-search-input');

        this.displayedEpisodes = 20;
        this.availableEpisodes = this.items.length;
        this.filteredItems = null;

        this.input.on('keyup', () => { 
            this.filterEpisodes(this.input.val()); 
        });

        this.filterEpisodes(this.input.val());

        this.loadMore.on('click', e => {
            e.preventDefault();
            this.loadMoreEpisodes();
        });

        this.categorySelector.on('change', e => {
            this.selectedCategory = this.categorySelector.val();
            this.filterEpisodes(this.input.val());
        });

        let urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('odcinek') && urlParams.get('odcinek').match(/^[0-9]{1,3}$/gmi)) {
            this.input.val(parseInt(urlParams.get('odcinek'), 10));
            this.input.trigger('keyup');
        }
    }

    fixSearchAttributes () {
        this.items.each((i, item) => {
            let searchPhrase = $(item).attr('data-episode-title').replace(/&nbsp;/gmi, ' ').replace(/\s/gmi, ' ').toLocaleLowerCase();
            $(item).attr('data-episode-title', searchPhrase);

            $(item).find('.episodes-list-item-category').on('click', e => {
                e.preventDefault();
                this.input.val('');
                this.selectedCategory = $(e.target).attr('data-category-id');
                this.categorySelector.val(this.selectedCategory);
                this.categorySelector.trigger('change');

                $('.site-main')[0].scrollIntoView();
            });
        });
    }

    filterEpisodes (searchPhrase) {
        if (searchPhrase.trim() === '' && this.selectedCategory === '') {
            this.filteredItems = this.items;
            this.limitDisplayedEpisodes();
            return;    
        }

        if (searchPhrase.trim() === '' && this.selectedCategory !== '') {
            this.filteredItems = this.items.filter('[data-episode-category-id="' + parseInt(this.selectedCategory, 10) + '"]');
            this.limitDisplayedEpisodes();
            return;
        }

        if (searchPhrase.match(/^[0-9]{1,3}$/gmi)) {
            this.filteredItems = this.items.filter('[data-episode-number="' + parseInt(searchPhrase, 10) + '"]');
            this.limitDisplayedEpisodes();
            return;
        }

        let selector = '[data-episode-title*="' + searchPhrase.replace(/\s/gmi, ' ').toLocaleLowerCase() + '"]';

        if (this.selectedCategory !== '') {
            selector += '[data-episode-category-id="' + parseInt(this.selectedCategory, 10) + '"]';
        }

        this.filteredItems = this.items.filter(selector);
        this.limitDisplayedEpisodes();

        if (this.filteredItems.length) {
            $('.episodes-list-empty-state').addClass('is-hidden');
        } else {
            $('.episodes-list-empty-state').removeClass('is-hidden');
        }
    }

    limitDisplayedEpisodes () {
        this.items.addClass('is-hidden');
        this.displayedEpisodes = 20;
        this.availableEpisodes = this.filteredItems.length;

        if (this.availableEpisodes > this.displayedEpisodes) {
            for (let i = 0; i < 20; i++) {
                this.filteredItems.eq(i).removeClass('is-hidden');
            }

            this.loadMore.removeClass('is-hidden');
        } else {
            this.filteredItems.removeClass('is-hidden');
            this.loadMore.addClass('is-hidden');
        }
    }

    loadMoreEpisodes () {
        let start = this.displayedEpisodes;
        this.displayedEpisodes += 20;

        for (let i = start; i < this.displayedEpisodes; i++) {
            if (i > this.availableEpisodes) {
                break;
            }

            this.filteredItems.eq(i).removeClass('is-hidden');
        }

        if (this.displayedEpisodes >= this.availableEpisodes) {
            this.loadMore.addClass('is-hidden');
        }
    }
}